const organizationalStructureSetting = () => import('@/view/organizationalStructure/organizational-structure-setting'); //
const staffManage = () => import('@/view/organizationalStructure/staff-manage'); //
const partners = () => import('@/view/organizationalStructure/partners'); //

export default [{
    path: '/organizational-structure-setting',
    name: 'organizationalStructureSetting',
    component: organizationalStructureSetting
},{
    path: '/staff-manage',
    name: 'staffManage',
    component: staffManage
},{
    path: '/partners',
    name: 'partners',
    component: partners
}];